import React, { Component } from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';

class Loading extends Component {
    render() {
        return (
            <div className="container p-5">
                <div className="row">
                    <div className="col-lg-5 offset-lg-3 col-10 offset-1 w3-white w3-card ">
                        <div className="row">
                            <div className="col-lg-12 p-5">
                                <Dimmer active inverted>
                                    <Loader content={"Please wait..."} />
                                </Dimmer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Loading;